import React from 'react'

import { useReactFormContext } from './Form'

/** @deprecated */
export function InnerForm({ children, ...rest }: React.PropsWithChildren<any>) {
  const { handleSubmit } = useReactFormContext()
  return <form onSubmit={handleSubmit} {...rest} children={children} />
}
